import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Subject } from 'rxjs';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container } from '../../../symphony';

import { useComponentWillMount } from '../../../shared/public/SlUtils/useComponentWillMount';
import { QuestionPage } from '../../private/components/QuestionPage/QuestionPage';
import { SlDiscussContext } from '../../private/global-constants';
import { SlActionsService } from '../../private/services/ActionsService/sl-actions.service';
import { QuestionsListPage } from '../../private/components/QuestionsListPage/QuestionsListPage';
import { ModalsWrapper } from '../../private/components/Modals/ModalsWrapper';
import { SlFooter } from '../../../navigation/public/SlFooter/SlFooter';

import s from './SlDiscuss.scss';

export function SlDiscuss(): JSX.Element {
	useStyles(s);
	const { pathname } = useLocation();

	useComponentWillMount(() => {
		const unsubscriber = new Subject<void>();
		Container.register(SlDiscussContext, 'unsubscriber', unsubscriber);

		Container.take(SlDiscussContext, SlActionsService);
	});

	return (
		<main className="sl-discuss">
			<Routes>
				<Route
					path="/:id/:alias"
					element={<QuestionPage key={pathname.split('/')[pathname.split('/').length - 1]} />}
				/>
				<Route
					path="/:id"
					element={<QuestionPage key={pathname.split('/')[pathname.split('/').length - 1]} />}
				/>
				<Route path="/" element={<QuestionsListPage />} />
			</Routes>
			<ModalsWrapper />
			<SlFooter />
		</main>
	);
}
